export default 'VIEWED_HOTELS_CHANGED';
